export default "__VITE_ASSET__Bj5R5GOE__"